import { MAIN_ROUTE_NAME } from '@/libs/route-name';
import { RouteRecordRaw } from 'vue-router';

export const dashboardRoutes: RouteRecordRaw = {
    path: '',
    component: () => import('@/layouts/main.vue'),
    children: [
        {
            path: '',
            redirect: { name: MAIN_ROUTE_NAME.DASHBOARD },
        },
        {
            path: 'dashboard',
            name: MAIN_ROUTE_NAME.DASHBOARD,
            component: () => import('@/pages/dashboard/index.vue'),
            meta: {
                requireAuth: true,
            },
        },
    ],
};
